import { Inject, Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { AuthService as ExternalAuthService } from './external-auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Env } from '@usimweb/core/models';

type Apps = 'foaming' | 'molded' | 'mapper' | 'vela';
type AppsName = 'FOAMING' | 'MOLDED' | 'MAPPER';

const appsTable: Record<Apps, AppsName> = {
  foaming: 'FOAMING',
  molded: 'MOLDED',
  mapper: 'MAPPER',
  vela: 'FOAMING',
};

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  private APP_NAME = '';
  private readonly DEFAULT_ROUTE = '/';

  constructor(
    @Inject('environment') private environment: Env,
    private router: Router,
    private authService: AuthService,
    private externalAuthService: ExternalAuthService,
    private snackBar: MatSnackBar
  ) {
    this.APP_NAME = environment.APP.toUpperCase();
  }

  public canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    // console.log('called auth guard');
    // console.log(this.environment);
    // console.log(this.authService.accessToken);

    // console.log('version cookie');
    // console.log(this.authService.version);

    // console.log('all cookies');
    // console.log(this.authService.allCookies);

    if (this.environment.deployment === 'appstore') {
      //FIXME cookie sometimes undefined, but its in the browser storage
      return true;
      if (!this.authService.accessToken) {
        this.router.navigate([this.DEFAULT_ROUTE]);
        return false;
      } else {
        return true;
      }
    } else if (!this.externalAuthService.isTokenExpired() && this.environment.deployment !== 'appstore') {
      const decodedToken = this.externalAuthService.decodedToken;

      console.log('federation_attribute');
      console.log(this.environment.federation_attribute);

      if (decodedToken.hasOwnProperty(this.environment.federation_attribute)) {
        const roles = decodedToken[this.environment.federation_attribute];

        const appsMapper = (app: Apps): AppsName | 'app not found' =>
          appsTable[app.toLocaleLowerCase() as Apps] || 'app not found';
        const app = appsMapper(this.APP_NAME as any);

        console.log('roles');
        console.log(roles);
        console.log(app);

        if (
          roles.indexOf('cn=SG_ULTRASIM_' + app + ',ou=Groups,ou=3IAM,o=EXTERNAL') > -1 ||
          roles.indexOf('cn=SG_ULTRASIM_' + app + ',ou=3IAM,o=EXTERNAL') > -1
        ) {
          return true;
        }
      } else if (decodedToken.hasOwnProperty('upn')) {
        return true;
      }

      this.snackBar.open(
        'Please contact the BASF Ultrasim team for help. You do not have access to ' +
          this.APP_NAME +
          ' application...',
        'OK',
        { duration: 5000 }
      );

      setTimeout(() => {
        this.router.navigate([this.DEFAULT_ROUTE]);
      }, 5000);

      return false;
    } else if (this.environment.deployment === 'appstore' && !this.authService.accessToken) {
      this.router.navigate([this.DEFAULT_ROUTE]);
      return false;
    } else if (this.environment.deployment === 'ultrasimweb') {
      if (!this.externalAuthService.accessToken) {
        this.router.navigate([this.DEFAULT_ROUTE]);
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }
}
